import type { PropsWithChildren } from 'react';

import { useSecretDetail } from '../../../hooks';
import type { Secret } from '../../../types';
import { SecretDetailContext } from './context';

export interface SecretDetailProviderProps extends PropsWithChildren {
    id: Secret['id'];
}

export const SecretDetailProvider = ({ children, id }: SecretDetailProviderProps) => {
    const detail = useSecretDetail(id);

    return <SecretDetailContext.Provider value={(detail ?? null) as Secret | null}>{children}</SecretDetailContext.Provider>;
};
